import {OrderManager, PaymentType, Payment, PaymentAdapter} from '@nuskin/ns-shop';
import PromoCodeOffers from './promoCodeOffers.js';
import {getCachedConfigField} from '@nuskin/configuration-sdk';


const PaymentUtil = function() {
    'use strict';

    let $scope;
    let previousPayment = {};

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {
        initPayments: function(scope) {
            $scope = scope;

            if (getCachedConfigField('showPaymentPromoCodeOffers')) {
                PromoCodeOffers.initPromoCodeOffers($scope);
            } else {
                PromoCodeOffers.initBasicPromoCode($scope);
            }
        },

        injectPaymentComponent: function() {
            let adrPayment = null;

            if ($scope.overriddenADR) {
                const sapPayment = $scope.overriddenADR.SalesOrderDetail.Payment[0];
                if (sapPayment) {
                    adrPayment = PaymentAdapter.mapSAPPaymentToPayment(sapPayment);
                    adrPayment.sapPaymentObject = sapPayment;
                }
            }

            // eslint-disable-next-line no-undef
            const appCfg = __APP_CONFIG__;
            let initialValue = '';
            if ($scope.order.selectedPayment && $scope.order.selectedPayment.bePaymentTypeId) {
                initialValue = JSON.stringify($scope.order.selectedPayment);
            }
            if (adrPayment) {
                if (adrPayment.paymentName) {
                    adrPayment.paymentName = adrPayment.paymentName.replace(/'/g, '&apos;');
                }
                initialValue = JSON.stringify(adrPayment);
            } else if ($scope.paymentPref === 'paypal' && !$scope.order.adr) {
                initialValue = JSON.stringify({paymentTypeId: PaymentType.PPAL});
            }

            initialValue = initialValue.replace(/"/g, '&quot;');
            // eslint-disable-next-line
            const paymentComponent = `<ns-payment-selector
                id="newPaymentSection"
                context="CHECKOUT"
                use-billing-address="${getCachedConfigField('useNewBillingAddress')}"
                cs-api-key="${appCfg.contentstack.apiKey}"
                cs-delivery-token="${appCfg.contentstack.deliveryToken}"
                cs-environment="${appCfg.contentstack.environment}"
                order-type="${$scope.order.orderType}"
                initial-value='${initialValue}'
            />`;

            document.getElementById('checkout-payment-selector').innerHTML = paymentComponent;
            const paymentElement = document.getElementById('newPaymentSection');
            initPaymentComponentListeners(paymentElement);
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------

    /**
     * Adds event listeners to payment component to integrate with the angular checkout application
     * @param paymentElement dom element for the new payment component
     */
    function initPaymentComponentListeners(paymentElement) {
        if (paymentElement && typeof paymentElement.addEventListener === 'function') {
            paymentElement.addEventListener('input', (event) => {
                // Set the payment on the order object
                if (event.detail && event.detail.length > 0) {
                    $scope.order.selectedPayment = new Payment(event.detail[0]);
                    if ($scope.paymentState === 'complete' && needToSimulate()) {
                        $scope.simulateOrder().then(() => previousPayment = $scope.order.selectedPayment);
                    }
                }
            });
            paymentElement.addEventListener('state', (event) => {
                if (event.detail && event.detail.length > 0) {
                    $scope.paymentState = event.detail[0];
                    if ($scope.paymentState === 'complete' && $scope.sections.initialized) {
                        if (needToSimulate()) {
                            $scope.simulateOrder().then(() => {
                                previousPayment = $scope.order.selectedPayment;
                                $scope.continueEdit('payment');
                            });
                        } else {
                            previousPayment = $scope.order.selectedPayment;
                            OrderManager.saveOrders();
                            $scope.continueEdit('payment');
                        }
                    }
                    if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
                        $scope.$apply();
                    }
                }
            });
            paymentElement.addEventListener('availablePayments', (event) => {
                if (event.detail && event.detail.length > 0) {
                    $scope.order.availablePayments = event.detail[0];
                }
            });
            paymentElement.addEventListener('cvv', (event) => {
                if (event.detail && event.detail.length > 0) {
                    $scope.order.paymentSecurityNumber = event.detail[0];
                }
            });
        }
    }

    function needToSimulate() {
        let prevInstalmment = previousPayment.installmentSelectedNumber;
        let orderInstallment = $scope.order.selectedPayment.installmentSelectedNumber;

        if (typeof prevInstalmment !== 'number' || isNaN(prevInstalmment)) prevInstalmment = -1;
        if (typeof orderInstallment !== 'number' || isNaN(orderInstallment)) orderInstallment = -1;

        return prevInstalmment != orderInstallment;
    }

    return publicMethods;
}();

export default PaymentUtil;
